import React from 'react';

import { FormItem } from '../shared/FormItem';
import { Input, InputProps } from './Input';

export type InputItemProps = {
  label?: string;
  required?: boolean;
  error?: string;
  className?: string;
  description?: string;
  suffix?: JSX.Element;
  inputClassName?: string;
} & Omit<InputProps, 'hasError'>;

export const InputItem = React.forwardRef<HTMLInputElement, InputItemProps>(
  (props, ref) => {
    const {
      name,
      required,
      error,
      label,
      className,
      description,
      inputClassName,
      ...inputProps
    } = props;

    return (
      <FormItem
        className={className}
        name={name}
        label={label}
        required={required}
        description={description}
        error={error}
        dataTestId={`${inputProps['data-testid']}-wrapper`}
      >
        <Input
          ref={ref}
          type="text"
          name={name}
          id={name}
          hasError={!!error}
          className={inputClassName}
          {...inputProps}
        />
      </FormItem>
    );
  }
);

InputItem.displayName = 'InputItem';
